<template>
  <div class="common_foot">
    <div class="content_wrap">
      <div class="content">
        <div class="phone_icon">
          <img src="../../assets/image/common/new/logo_foot.png" class="pic_full" />
        </div>
        <div class="divider"></div>
        <div class="help_info">
          <div class="item">
            <div class="title">
              <span class="icon">
                <img src="../../assets/image/common/icon (24).png" class="pic_full" />
              </span>
              <span class="text">服务保障</span>
            </div>
          </div>
          <div class="item">
            <div class="title">
              <span class="icon">
                <img src="../../assets/image/common/icon (28).png" class="pic_full" />
              </span>
              <span class="text">我是新手</span>
            </div>
          </div>
          <div class="item no_mr">
            <div class="title">
              <span class="icon">
                <img src="../../assets/image/common/icon (27).png" class="pic_full" />
              </span>
              <span class="text">用户协议</span>
            </div>
            <div class="item_detail">
              <a target="_blank" href="https://gemsbaby.com/user_agreement.html">用户协议</a>
            </div>
            <div class="item_detail">
              <a  target="_blank" href="https://gemsbaby.com/privacy_policies.html">隐私政策</a>
            </div>
          </div>
          
          <p class="url">友情链接：鲸贝英语</p>
        </div>
        <div class="qr_code_area">
          <span class="qr_code">
            <img src="../../assets/image/common/qr_code.jpg" class="pic_full" />
          </span>
          <p class="info">鲸贝英语服务号</p>
        </div>
      </div>
      <div class="divider_b"></div>
      <div class="company_address">
        <div class="copyright">Copyright ©2019 Gemsbaby Corporation. All rights reserved. 粤ICP备19034907号-2</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
<style scoped src="./common_foot.css"></style>
